import { useMemo, useState } from 'react'
import MovimentacaoLastMileHttp from '../../../../services/api/https/patrimonio/movimentacao-last-mile.http'
import { getPeriodoMesAtual } from '../../../../services/util/date.service'
import { errorHandler } from '../../../../services/util/error.service'
import { gerarArquivoExcel } from '../../../../services/util/excel.service'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  GET_CANHOTOS: 'Adquirindo canhotos',
  UPDATE_CANHOTO: 'Validando canhoto',
  UPLOAD_CANHOTOS: 'Fazendo o upload dos canhotos',
  SUCCESS: 'Canhoto atualizado com sucesso',
}

const INITIAL_STATE = {
  canhotos: [],
  modal: {
    show: false,
    data: null,
  },
  observacaoModal: {
    show: false,
    canhotoId: null,
    canhotoLabel: '',
    observacao: '',
  },
  clienteModal: {
    show: false,
    canhotoId: null,
    canhotoLabel: '',
    clienteAssociado: null,
  },
  selectedStatus: ['Pendente'],
  statusToUpdate: '',
  periodo: getPeriodoMesAtual(),
  fileContent: null,
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
}

export const DROPDOWN_OPTIONS = [
  { label: 'Pendente', value: 'Pendente' },
  { label: 'OK', value: 'OK' },
  { label: 'Recusado', value: 'Recusado' },
]

export const STATUS = {
  OK: 'OK',
  RECUSADO: 'Recusado',
  PENDENTE: 'Pendente',
}

export default function useValidacaoCanhoto() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    //Helpers

    return {
      //Actions
      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
        }))
      },

      getMenuItems() {
        return ['Detalhes', 'Upload Canhoto', 'Observação', 'Associar Cliente']
      },

      getCanhotos(tpsIds, status, pInicial, pFinal) {
        if (status.length === 0)
          setState(prevState => ({ ...prevState, errorMessage: 'Selecione Pelo Menos UM Status' }))
        else
          MovimentacaoLastMileHttp.getCanhotosByStatus(tpsIds, status, pInicial, pFinal)
            .then(canhotos => {
              setState(prevState => ({
                ...prevState,
                canhotos: canhotos,
                loadingMessage: LOAD_MESSAGE.NONE,
              }))
            })
            .catch(err =>
              setState(prevState => ({
                ...prevState,
                errorMessage: errorHandler(err),
                loadingMessage: LOAD_MESSAGE.NONE,
              })),
            )
      },

      updateCanhotosStatus(canhotos, status) {
        MovimentacaoLastMileHttp.updateCanhotosStatus({ canhotos_ids: canhotos, status: status })
          .then(canhotos =>
            setState(prevState => {
              canhotos.forEach(c => {
                const index = prevState.canhotos.findIndex(co => co.id === c.id)
                if (index !== -1) prevState.canhotos[index].status = status
              })
              prevState.loadingMessage = LOAD_MESSAGE.SUCCESS
              return { ...prevState }
            }),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      importarCanhotos(data, selectedTp) {
        MovimentacaoLastMileHttp.importCanhotos(data, selectedTp)
          .then(response =>
            setState(prevState => {
              response.updatedCanhotos.forEach(c => {
                const index = prevState.canhotos.findIndex(co => co.id === c.id)
                if (index !== -1) prevState.canhotos[index].status = c.status
              })
              if (response.warningMessage) {
                prevState.loadingMessage = LOAD_MESSAGE.NONE
                prevState.errorMessage = response.warningMessage
              } else prevState.loadingMessage = LOAD_MESSAGE.SUCCESS
              return { ...prevState }
            }),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      //Events
      onResponse(type) {
        switch (type) {
          case 'close':
            setState(prevState => ({ ...prevState, modal: { show: false, data: null } }))
            break

          default:
            break
        }
      },

      closeObservacaoModal() {
        setState(prevState => ({
          ...prevState,
          observacaoModal: { show: false, canhotoId: null, canhotoLabel: '', observacao: '' },
        }))
      },

      onObservacaoChange(value) {
        setState(prevState => ({
          ...prevState,
          observacaoModal: { ...prevState.observacaoModal, observacao: value },
        }))
      },

      saveObservacao(canhotoId, observacao) {
        MovimentacaoLastMileHttp.updateObservacao(canhotoId, observacao || null)
          .then(() =>
            setState(prevState => {
              const index = prevState.canhotos.findIndex(c => c.id === canhotoId)
              if (index !== -1) prevState.canhotos[index].observacao = observacao
              return {
                ...prevState,
                canhotos: [...prevState.canhotos],
                observacaoModal: { show: false, canhotoId: null, canhotoLabel: '', observacao: '' },
              }
            }),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
            })),
          )
      },

      closeClienteModal() {
        setState(prevState => ({
          ...prevState,
          clienteModal: { show: false, canhotoId: null, canhotoLabel: '', clienteAssociado: null },
        }))
      },

      saveClienteId(canhotoId, cliente) {
        const clientId = cliente ? cliente.id : null
        const clientName = cliente ? cliente.nomeFantasia : null
        MovimentacaoLastMileHttp.updateClientId(canhotoId, clientId)
          .then(() =>
            setState(prevState => {
              const index = prevState.canhotos.findIndex(c => c.id === canhotoId)
              if (index !== -1) {
                prevState.canhotos[index].client_id = clientId
                prevState.canhotos[index].client_name = clientName
              }
              return {
                ...prevState,
                canhotos: [...prevState.canhotos],
                clienteModal: { show: false, canhotoId: null, canhotoLabel: '', clienteAssociado: null },
              }
            }),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
            })),
          )
      },

      onMenuItemClick(item, data, history, selectedTp) {
        switch (item) {
          case 'Detalhes':
            setState(prevState => ({ ...prevState, modal: { show: true, data: data } }))
            break

          case 'Upload Canhoto':
            history.push({
              pathname: '/main/patrimonio/validacao-canhoto/upload-canhoto',
              state: { canhoto_id: data.id, num_nf_canhoto: data.num_nf_canhoto },
            })
            break

          case 'Observação':
            setState(prevState => ({
              ...prevState,
              observacaoModal: {
                show: true,
                canhotoId: data.id,
                canhotoLabel: data.num_nf_canhoto,
                observacao: data.observacao || '',
              },
            }))
            break

          case 'Associar Cliente':
            if (!selectedTp || selectedTp === 0) {
              setState(prevState => ({
                ...prevState,
                errorMessage: 'Selecione um TP',
              }))
              break
            }
            setState(prevState => ({
              ...prevState,
              clienteModal: {
                show: true,
                canhotoId: data.id,
                canhotoLabel: data.num_nf_canhoto,
                clienteAssociado: data.client_id
                  ? { id: data.client_id, nomeFantasia: data.client_name }
                  : null,
              },
            }))
            break

          default:
            break
        }
      },

      onStatusSelectedChange(value) {
        setState(prevState => ({ ...prevState, selectedStatus: value }))
      },

      onInit() {
        setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.GET_CANHOTOS }))
      },

      onFilterClick() {
        setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.GET_CANHOTOS }))
      },

      onBtnPesquisarClick(pInicial, pFinal) {
        setState(prevState => ({
          ...prevState,
          periodo: { dataInicial: pInicial, dataFinal: pFinal },
          loadingMessage: LOAD_MESSAGE.GET_CANHOTOS,
        }))
      },

      onItemClicked(canhoto) {
        setState(prevState => {
          canhoto.selected = typeof canhoto.selected !== 'boolean' ? true : !canhoto.selected
          const index = prevState.canhotos.findIndex(c => c.id === canhoto.id)
          if (index !== -1) prevState.canhotos[index] = canhoto
          return { ...prevState }
        })
      },

      onButtonStatusClick(status, canhotos) {
        if (canhotos.filter(c => c.selected).length === 0)
          setState(prevState => ({
            ...prevState,
            errorMessage:
              'Para alterar o status é necessario selecionar pelo menos 1 item da tabela.',
          }))
        else
          setState(prevState => ({
            ...prevState,
            statusToUpdate: status,
            loadingMessage: LOAD_MESSAGE.UPDATE_CANHOTO,
          }))
      },

      async onBtnExportarExcel(canhotos) {
        const colunas = [
          [
            'id',
            'NF Canhoto',
            'Data',
            'Op. Logístico',
            'Transportadora',
            'Placa',
            'Patrimonio',
            'Qte',
            'Status',
            'Imagem Canhoto',
            'Observação',
            'Cliente',
          ],
        ]

        canhotos.forEach(c => {
          colunas.push([
            c.id,
            c.num_nf_canhoto,
            c.prestacao_contas_data,
            c.tp_name,
            c.transportadora_name,
            c.vehicle_badge,
            c.patrimonio_name,
            c.qte,
            c.status,
            c.path_canhoto || '',
            c.observacao || '',
            c.client_name || '',
          ])
        })

        gerarArquivoExcel(
          'canhotos',
          colunas,
          `Canhotos_${new Date().toLocaleString().slice(0, 10)}.xlsx`,
        )
      },

      async onBtnImportarClick(content) {
        setState(prevState => ({
          ...prevState,
          fileContent: content,
          loadingMessage: LOAD_MESSAGE.UPLOAD_CANHOTOS,
        }))
      },
    }
  }, [])

  return { state, localDispatch }
}
